<template>
  <component
    :is="element"
    :id="block.id"
    :href="block.settings.usp_card_link"
    class="usp-card"
    :class="[
      blockClass,
      `usp-card--${block.settings['usp_card_type']}`,
      `usp-card-background--${block.settings['background_color']}`,
      `usp-card-text-color--${block.settings['text_color']}`,
    ]"
  >
    <div
      v-if="block.settings.usp_card_type !== 'image'"
      class="usp-card__content-container"
    >
      <div
        v-if="block.settings.usp_card_icon ||
          block.settings.eyebrow ||
          block.settings.usp_card_copy ||
          (block.settings.usp_card_cta && block.settings.usp_card_link)"
        class="usp-card__content--center"
      >
        <img
          v-if="block.settings['usp_card_icon']"
          :alt="$string('accessibility.icon')"
          :src="block.settings['usp_card_icon']"
          class="usp-card__icon"
        >

        <Eyebrow
          v-if="block.settings['eyebrow']"
          :enable-bullet="block.settings['eyebrow_bullet']"
          :modifier="'usp-card__eyebrow'"
          :text="block.settings['eyebrow']"
        />

        <div
          v-if="block.settings['usp_card_copy']"
          class="usp-card__copy h6"
        >
          {{ block.settings['usp_card_copy'] }}
        </div>
      </div>

      <div
        v-if="block.settings['usp_card_cta'] && block.settings['usp_card_link']"
        class="usp-card__cta button button--text"
      >
        <span
          class="button__label button__label--no-icon"
          v-text="block.settings['usp_card_cta']"
        />
      </div>
    </div>

    <template v-if="block.settings.usp_card_type !== 'text'">
      <div
        v-if="block.settings['usp_card_link'] &&
          block.settings['usp_card_image']"
        class="usp-card__image-link"
      >
        <img
          v-if="block.settings['usp_card_image']"
          :alt="block.settings['usp_card_cta']"
          :src="block.settings['usp_card_image']"
          class="usp-card__image"
        >
      </div>

      <img
        v-if="block.settings['usp_card_image'] &&
          !block.settings['usp_card_link']"
        :alt="$string('accessibility.image', {
          replace: {
            description: 'USP'
          }
        })"
        :src="block.settings['usp_card_image']"
        class="usp-card__image"
      >
    </template>
  </component>
</template>

<script>

/**
 * Vue: USP card (usp-card)
 * -----------------------------------------------------------------------------
 * Card snippet to be used in carousels.
 *
 */
import Eyebrow from '../../global/eyebrow/eyebrow'

export default {
  name: 'UspCard',
  components: {
    Eyebrow,
  },
  props:{
    block: {
      type: Object,
      required: true,
    },
    blockClass: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    element() {
      return this.block.settings.usp_card_link ? 'a' : 'div'
    },
  },
}
</script>

<style lang="scss">
@import './usp-card';
</style>
